/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Spanish (International)
export default {
  'share-modal.accordion-button-label':
    '{entity, select, project {¿Quién recibe actualizaciones semanales del proyecto?} goal {¿Quién recibe actualizaciones semanales de las metas?} other {¿Quién recibe actualizaciones semanales?}}',
  'share-modal.add-as-follower-checkbox-label': 'Añadir como seguidor',
  'share-modal.add-as-follower-checkbox-tooltip':
    '{entity, select, project {Los seguidores reciben una actualización semanal del proyecto en su resumen} goal {Los seguidores reciben una actualización semanal de la meta en su resumen} other {Los seguidores reciben una actualización semanal de su  en su resumen}}',
  'share-modal.all-tab-label': 'Todos',
  'share-modal.contributors-tab-label': 'Colaboradores',
  'share-modal.followers-tab-label': 'Seguidores',
  'share-modal.followers-title': 'Seguidores',
  'share-modal.footer.access-level-disclaimer':
    '{entity, select, project {Todos los usuarios con acceso al espacio de trabajo pueden ver este proyecto.} goal {Todos los usuarios con acceso al espacio de trabajo pueden ver esta meta.} other {Todos los usuarios con acceso al espacio de trabajo pueden ver esta .}}',
  'share-modal.footer.access-level-private-disclaimer':
    '{entity, select, project {Proyecto privado} goal {Meta privada} other {}}',
  'share-modal.footer.copy-link-button': 'Copiar enlace',
  'share-modal.footer.copy-link-button.copied-tooltip': '¡Copiado!',
  'share-modal.footer.copy-link-button.tooltip':
    '{entity, select, project {Copiar enlace en el proyecto} goal {Copiar enlace en la meta} other {Copiar enlace a }}',
  'share-modal.modal.user-picker.add-more-placeholder': 'Añadir más personas',
  'share-modal.share-button': 'Compartir',
  'share-modal.share-title': 'Compartir',
  'share-modal.user-item.can-edit-label': 'Puede editar',
  'share-modal.user-picker.placeholder': 'Busca e invita a personas',
  'shareModal.followers-empty-state.default-title': '¿Faltan partes interesadas clave?',
  'shareModal.followers-empty-state.goal-cta':
    'Asegúrate de que reciben las últimas novedades sobre tu meta en su resumen mensual añadiéndolos como seguidores o conecta un canal de Slack o MS Teams.',
  'shareModal.followers-empty-state.project-cta':
    'Añade como seguidores a los equipos y partes interesadas clave para mantenerlos informados. Conecta un canal para compartir actualizaciones directamente en el chat.',
  'shareModal.followers-empty-state.project-title': 'Llega a un público más amplio añadiendo seguidores',
};
